<template>
  <div id="HeaderLgd">
      <b-navbar toggleable="xl" type="dark" variant="info" class="hdr">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item @click="showItemsList()"><b>{{$t('NEWS')}}</b></b-nav-item>
                <b-nav-item @click="showTravels()"><b>{{$t('TRAVELS')}}</b></b-nav-item>
                <b-nav-item @click="showOffers()"><b>{{$t('OFFERS')}}</b></b-nav-item>
                <!-- <b-nav-item @click="showAuthorsList()"><b>{{$t('AUTHORS')}}</b></b-nav-item> -->
                <b-nav-form>
                    <b-input-group size=sm class="mr-sm-2" style="min-width:10em;max-width:15em">
                        <b-form-input v-model="searchTxt" @keydown.native.enter.prevent="search()"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-success" @click="search()"><font-awesome-icon icon="search" size="lg" :style="{ color: 'white' }" /></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-nav-form>
                <b-nav-item @click="share()"><b><font-awesome-icon icon="share-alt" size="lg" :style="{ color: 'white' }" /></b></b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item disabled><b>{{$t('MY')}}:</b></b-nav-item>
                <b-nav-item-dropdown>
                    <template v-slot:button-content>
                        <b>{{$t('MAP')}}</b>
                    </template>
                    <b-dropdown-item href="#" @click="showUserMap(Cnst.PUBLISHED)">{{$t('PUBLISHED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="showUserMap(Cnst.UNPUBLISHED)">{{$t('UNPUBLISHED')}}</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown>
                    <template v-slot:button-content>
                        <b>{{$t('PLACES')}}</b>
                    </template>
                    <b-dropdown-item href="#" @click="showUserPlacesList(Cnst.PUBLISHED)">{{$t('PUBLISHED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="showUserPlacesList(Cnst.UNPUBLISHED)">{{$t('UNPUBLISHED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" v-if="user.hasBlockedPlaces" @click="showUserPlacesList(Cnst.ANY_PUBLISHED, Cnst.BLOCKED)">{{$t('BLOCKED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="createPlace()">{{ $t('CREATE') }}</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown>
                    <template v-slot:button-content>
                        <b>{{$t('TRIPS')}}</b>
                    </template>
                    <b-dropdown-item href="#" @click="showUserTripsList(Cnst.PUBLISHED)">{{ $t('PUBLISHED') }}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="showUserTripsList(Cnst.UNPUBLISHED)">{{ $t('UNPUBLISHED') }}</b-dropdown-item>
                    <b-dropdown-item href="#" v-if="user.hasBlockedTrips" @click="showUserTripsList(Cnst.ANY_PUBLISHED, Cnst.BLOCKED)">{{$t('BLOCKED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="createTrip()">{{ $t('CREATE') }}</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown>
                    <template v-slot:button-content>
                        <b>{{$t('CMNTS')}}</b>
                    </template>
                    <b-dropdown-item href="#" @click="showUserCmntsList(Cnst.PUBLISHED)">{{$t('PUBLISHED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="showUserCmntsList(Cnst.UNPUBLISHED)">{{$t('UNPUBLISHED')}}</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-if="user.userType==='g' || user.userType==='c'">
                    <template v-slot:button-content>
                        <b>{{$t('OUTINGS')}}</b>
                    </template>
                    <b-dropdown-item href="#" @click="showUserOutingsList(Cnst.PUBLISHED)">{{ $t('PUBLISHED') }}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="showUserOutingsList(Cnst.UNPUBLISHED)">{{ $t('UNPUBLISHED') }}</b-dropdown-item>
                    <b-dropdown-item href="#" v-if="user.hasBlockedOutings" @click="showUserOutingsList(Cnst.ANY_PUBLISHED, Cnst.BLOCKED)">{{$t('BLOCKED')}}</b-dropdown-item>
                    <b-dropdown-item href="#" @click="createOuting()">{{ $t('CREATE') }}</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item href="#" @click="$showDoc('Help')"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-nav-item>
                <b-nav-item @click="toOffl()" v-show="app"><b>{{$t('TO_OFFL')}}</b></b-nav-item>
                <b-nav-item-dropdown right>
                    <template v-slot:button-content>
                        <b-avatar :src="avatarUrl" size="1.4em"></b-avatar>
                    </template>
                    <b-dropdown-item @click="$logout()"><b>{{$t('SIGN_OUT')}}</b></b-dropdown-item>
                    <b-dropdown-item @click="manageUser"><b>{{$t('PROFILE')}}</b></b-dropdown-item>
                    <b-dropdown-item href="#" @click="$chIntLoc('ru')"><b-button><img src="./imgs/ru.png" alt="ru"></b-button> ru</b-dropdown-item>
                    <b-dropdown-item href="#" @click="$chIntLoc('en')"><b-button><img src="./imgs/en.png" alt="en"></b-button> en</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <ShareItem
              v-on:closeShare="closeShare"
              v-if="shareItem"
      />

  </div>

</template>

<script>
import { BNavbar, BCollapse, BNavbarToggle, BNavbarNav, BNavItem, BDropdownItem,
    BNavItemDropdown, BNavForm, BFormInput, BInputGroup, BInputGroupAppend, BButton, BAvatar } from 'bootstrap-vue';
import ShareItem from "./ShareItem.vue";
import {Cnst} from '@/plugins/Cnst.js';
//import { mapGetters } from 'vuex'

export default {
  name: 'HeaderLgd',
  components: {
    ShareItem,
    BNavbar, BCollapse, BNavbarToggle,  BNavbarNav,  BNavItem, BDropdownItem,
    BNavItemDropdown, BNavForm, BFormInput, BInputGroup, BInputGroupAppend, BButton, BAvatar
  },
  data: function() {
    return {
        intLoc: this.$i18n.locale,
        searchTxt: '',
        user: {},
        avatarKey: 0,
        avatarUrl: '',
        app: false,
        shareItem: false
      }
    },
  created() {
      this.Cnst = Cnst;
  },
  mounted() {
    this.$nextTick(function () {
        this.app = this.$store.state.app;
    });
    if(!this.$store.state.curUserName) this.$showErr(this.$t('TMOUT'), 401);
    //this.avatarUrl = '/data/avat/'+this.$store.state.curUserName+'.png';
    this.getUserR();
    window.addEventListener("beforeunload", this.leaving);
  },
  methods: {
    async getUserR() {
        try {
            const response = await this.$http.get('/getUserR', {
                params: {
                    userName: this.$store.state.curUserName
                }
            });
            this.user = response.data;
            this.avatarUrl = '/'+this.user.avatarUrl+"?key="+Math.random();
            this.$store.commit('setCurPos',
                { 'zoom': this.user.curZoom, 'lat': this.user.curLat, 'lng': this.user.curLng } );
                let userType = this.user.userType;
                if(userType!='t' && userType!='g' && userType!='c') userType = 't';
                //this.$store.commit('setCurUserName', this.user.userName);
                this.$store.commit('setCurUserType', userType);
                if(userType ==='g') this.$store.commit('setCurUserCompanyName', this.user.userName);
                else this.$store.commit('setCurUserCompanyName', this.user.companyName);
                this.$store.commit('setCurUserHomeUrl', this.user.homeUrl);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
            this.$store.commit('setCurUserName', '');
            this.$router.push({ path: '/' }).catch(() => {});
        }
    },
    leaving() {
        this.$logout();
        this.$store.commit('setCurUserName', '');
    },
    showItemsList() { this.$router.push({ path: '/ItemList' }).catch(() => {}) },
    showAuthorsList() { this.$router.push({ path: '/AuthorsList' }).catch(() => {}) },
    showTravels() { this.$router.push({  path: '/TravelGeo' }).catch( () => {} ) },
    showOffers() { this.$router.push({  path: '/OffersGeo' }).catch( () => {} ) },
    search() {
        if(!this.searchTxt) this.$bvModal.msgBoxOk(this.$t('EMPTY'));
        else {
            this.$router.push({
                path: '/Search',
                query: {
                    searchTxt: this.searchTxt
                }
            }).catch(() => {})
        }
    },
    showUserMap(published) {
        this.$router.push({
            path: '/Map/UserMap/'+'_/'+this.$addEncHyp(this.$store.state.curUserName),
            query: {
                published: published,
                blocked: false,
                free: false,
                posFromSrv: false,
                all: false
           }
        }).catch(() => {})
    },
    showUserPlacesList(published, blocked) {
        this.$router.push({
            path: '/UserPlacesList/'+this.$addEncHyp(this.$store.state.curUserName),
            query: {
                published: published,
                blocked: blocked,
                free: false
            }
        }).catch( () => {} );
    },
    showUserTripsList(published, blocked) {
        this.$router.push({
            path: '/UserTripsList/'+this.$addEncHyp(this.$store.state.curUserName),
            query: {
                published: published,
                blocked: blocked
            }
        }).catch( () => {} )
    },
    showUserOutingsList(published, blocked) {
        this.$router.push({
            path: '/UserOutingsList/'+this.$addEncHyp(this.$store.state.curUserName),
            query: {
                published: published,
                blocked: blocked
            }
        }).catch( () => {} )
    },
    showUserCmntsList(published) {
        this.$router.push({
            path: '/UserCmntsList/'+this.$addEncHyp(this.$store.state.curUserName),
            query: {
                published: published
            }
        }).catch( () => {} )
    },
    createTrip() {
        this.$router.push({
            path: '/ManageTrip/_'
        });
    },
    createPlace() {
        this.$router.push({
            path: '/Map/ManagePlaceMarker/_/_',
        });
    },
    createOuting() {
        this.$router.push({
            path: '/ManageOuting/_'
        });
    },
    manageUser() {
        this.$router.push({path: '/ManageUser'}).catch(() => {});
    },
    async toOffl() {
        this.$store.commit('setApp', false);
        this.app = false;
        try{
            await this.$http.get('userLogout');
            this.$store.commit('setCurUserName', '');
        } catch(error) {
            // *** will not work/ change for alert
            this.$showErr(error.response.data, error.response.status);
        }
        if(typeof AndroidInterface!='undefined') window.location = 'dist/index.html';
        else window.location = "/";
    },
    share() {
        this.shareItem = true;
    },
    closeShare() {
        this.shareItem = false;
    }
  },
  watch: {
    '$store.state.avatarKey': function() {
        this.avatarUrl = '/'+this.user.avatarUrl+"?key="+Math.random();
    }
  }
}

</script>

<style>
</style>
